var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-btn",class:_vm.customStyles,attrs:{"role":"button","disabled":_vm.disabled},on:{"click":function($event){(!_vm.disabled)? _vm.$emit('click') : false}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }